export default "__VITE_ASSET__DQO5$fKj__"